import { PresentationRole } from "@/apis/preview/v2/types";
import { RoleWithExtended } from "@/types/mapping";

export type GetTableAddressTable = {
  roleLabel: string;
  prefixRoleKey: string;
  tableId: string;
  start: string;
  end: string;
  factAddresses: string[];
  name: string;
  categoryId: string;
};

export type GetTableAddressesResponse = {
  tableAddresses: GetTableAddressTable[];
};

/** 워크북 보고 기간. Q4 는 사업보고서(연간)다. */
export enum ReportQuarter {
  Q1 = "Q1",
  Q2 = "Q2",
  Q3 = "Q3",
  Q4 = "Q4",
  AR = "AR",
}

enum IndustryType {
  NON_FINANCE = "NON_FINANCE", // 비금융업
  FINANCE_B = "FINANCE_B", // 금융업-은행
  FINANCE_I = "FINANCE_I", // 금융업-보험
  FINANCE_S = "FINANCE_S", // 금융업-증권
  FINANCE_X = "FINANCE_X", // 금융업-기타
}

export type GetWorkbookResponse = {
  id: string | null;
  name: string;
  displayName: string | null;
  revision: number;
  creator: string;
  companyName: string;
  companyCode: string;
  announcementDate: string | null;
  reportQuarter: ReportQuarter | null;
  reportYear: number | null;
  fiscalYearNumber: number | null;
  // 서버는 FinancialStatementType.value 를 그대로 내려준다 — 연결·별도를 함께 담은 워크북은 "BOTH"
  financialStatementType: "CONSOLIDATED" | "SEPARATE" | "BOTH" | null;
  industry: IndustryType | null;
  createdAt: Date;
  updatedAt: Date;
};

export type RegisteredTable = {
  id: string;
  name: string;
  excelSheetId: string;
  roleLabel: string;
  preKey: string;
};

export type GetRegisteredTableListResponse = {
  tables: RegisteredTable[];
};

export type CategoryInfo = {
  id: string;
  workbookId: string;
  category: string;
  preRole: PresentationRole;
  tables: RegisteredTable[];
};

export type GetCategoriesResponse = {
  categories: CategoryInfo[];
};

export type GetCellOfRoleResponse = {
  defRole: RoleWithExtended;
  lineItemKey: string | null;
};

export type GetDsdViewResponse = {
  html: string;
};

export type GetDsdViewsByNoteNumbersResponse = {
  views: {
    tableId: string;
    html: string;
    tableName: string;
    noteNumber: string;
  }[];
};

export type TableTaggingStatus = {
  tableId: string;
  /** member + line item 둘 다 붙은 셀이 있는지 (최종 미리보기의 "태깅됨" 기준) */
  hasTaggedCells: boolean;
  /** 태그가 하나라도 붙은 셀이 있는지 */
  hasAnyTaggedCells: boolean;
};

export type GetTablesTaggingStatusResponse = {
  tables: TableTaggingStatus[];
};
